import { useQuery } from "react-query"
import CompanyService from "~services/CompanyService"

const useCompanyWithLocation = (companyId: string) => {
  return useQuery(
    ["company", companyId],
    () => CompanyService.getCompanyWithLocation(companyId),
    { enabled: false }
  )
}
export default useCompanyWithLocation
